export const pathologyNames = [
    "cancerHistory.cancers.breastMale",
    "cancerHistory.cancers.breastFemale",
    "cancerHistory.cancers.dcis",
    "cancerHistory.cancers.colon",
    "cancerHistory.cancers.uterine",
    "cancerHistory.cancers.fallopian",
    "cancerHistory.cancers.gastric",
    "cancerHistory.cancers.melanoma",
    "cancerHistory.cancers.ovarian",
    "cancerHistory.cancers.pancreatic",
    "cancerHistory.cancers.peritoneal",
    "cancerHistory.cancers.prostate",
    "cancerHistory.cancers.adrenalCarcinoma",
    "cancerHistory.cancers.ampulla",
    "cancerHistory.cancers.bileDuct",
    "cancerHistory.cancers.biliaryTract",
    "cancerHistory.cancers.bladder",
    "cancerHistory.cancers.brainTumor",
    "cancerHistory.cancers.breastHyperplasia",
    "cancerHistory.cancers.breastLcis",
    "cancerHistory.cancers.cervix",
    "cancerHistory.cancers.chrpe",
    "cancerHistory.cancers.desmoidTumors",
    "cancerHistory.cancers.duodenalPolyps",
    "cancerHistory.cancers.duodenum",
    "cancerHistory.cancers.fibromas",
    "cancerHistory.cancers.stomachPolyps",
    "cancerHistory.cancers.glioblastoma",
    "cancerHistory.cancers.headNeck",
    "cancerHistory.cancers.hematological",
    "cancerHistory.cancers.hepatobiliary",
    "cancerHistory.cancers.hepatoblastoma",
    "cancerHistory.cancers.hodgkins",
    "cancerHistory.cancers.kidney",
    "cancerHistory.cancers.jejunalPolyps",
    "cancerHistory.cancers.jejunum",
    "cancerHistory.cancers.leukemia",
    "cancerHistory.cancers.lung",
    "cancerHistory.cancers.medulloblastoma",
    "cancerHistory.cancers.nevus",
    "cancerHistory.cancers.nevusAtypical",
    "cancerHistory.cancers.nevusDysplastic",
    "cancerHistory.cancers.nonEpithelialOvarian",
    "cancerHistory.cancers.osteomas",
    "cancerHistory.cancers.osteosarcoma",
    "cancerHistory.cancers.peritoneum",
    "cancerHistory.cancers.rectalPolyps",
    "cancerHistory.cancers.rectum",
    "cancerHistory.cancers.renalPelvis",
    "cancerHistory.cancers.sarcoma",
    "cancerHistory.cancers.sebaceous",
    "cancerHistory.cancers.smallIntestine",
    "cancerHistory.cancers.thyroid",
    "cancerHistory.cancers.upperGi",
    "cancerHistory.cancers.ureter",
    "cancerHistory.cancers.urinaryTract",
    "cancerHistory.cancers.notInThisList",
    "cancerHistory.cancers.other",
];
